module.exports = __webpack_public_path__ + "crm_static/img/banner_friendr@2x.974daf0f.png";